import * as React from 'react';
import { Collapse as MatCollapse, CollapseProps as MatCollapseProps, SxProps, Theme } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';

export interface CollapseProps {
  isOpen?: boolean;
  timeout?: MatCollapseProps['timeout'];
  unmountOnExit?: boolean;
  component?: React.ElementType<TransitionProps>;
  sx?: SxProps<Theme>;
}

const Collapse: React.FC<CollapseProps> = ({ isOpen, children, timeout, unmountOnExit, component, sx }) => {
  return (
    <MatCollapse in={isOpen} timeout={timeout} unmountOnExit={unmountOnExit} component={component} sx={sx}>
      {children}
    </MatCollapse>
  );
};

Collapse.defaultProps = {
  isOpen: true
};

Collapse.displayName = 'Collapse';

export { Collapse };
